import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

import Roles from './Roles';
import TruncatedRoles from './TruncatedRoles';

const END_DATE_KEY = 'endDate';

class RolesDetails extends Component {
  render() {
    const {
      maxItemsVisible,
      workExperience,
      showTasks,
      showAchievements,
      searchTerms,
      onShowMoreRolesClick,
      onEdit,
    } = this.props;
    const sortedRoles = sortBy(workExperience, END_DATE_KEY).reverse();

    if (maxItemsVisible) {
      return (
        <TruncatedRoles
          maxItemsVisible={maxItemsVisible}
          roles={sortedRoles}
          searchTerms={searchTerms}
          showAchievements={showAchievements}
          onShowMoreRolesClick={onShowMoreRolesClick}
          onEdit={onEdit}
        />
      );
    }
    return (
      <Roles
        showTasks={showTasks}
        roles={sortedRoles}
        showAchievements={showAchievements}
        searchTerms={searchTerms}
        onEdit={onEdit}
      />
    );
  }
}

RolesDetails.propTypes = {
  workExperience: PropTypes.arrayOf(PropTypes.object),
  showTasks: PropTypes.bool,
  showAchievements: PropTypes.bool,
  maxItemsVisible: PropTypes.number,
  searchTerms: PropTypes.arrayOf(PropTypes.string),
  onShowMoreRolesClick: PropTypes.func,
  onEdit: PropTypes.func,
};

RolesDetails.defaultProps = {
  workExperience: [],
  maxItemsVisible: null,
  searchTerms: [],
  showTasks: false,
  showAchievements: false,
  onShowMoreRolesClick: () => {},
  onEdit: null,
};

export default RolesDetails;
